import { Capacitor as Cap } from '@capacitor/core'
import { SafeArea } from 'capacitor-plugin-safe-area'
import { defineCustomElements } from '@ionic/pwa-elements/loader'
import { TextZoom } from '@capacitor/text-zoom'
import { LiveUpdate } from '@capawesome/capacitor-live-update'

export class Capacitor {
  static async init() {
    const isNative = await Cap.isNativePlatform()
    if (!isNative) return

    LiveUpdate.sync()

    defineCustomElements(window)

    TextZoom.set({ value: 1 })

    const platform = await Cap.getPlatform()
    if (platform == 'android') return

    await this.initSafeArea()
  }

  static async initSafeArea() {
    SafeArea.getSafeAreaInsets().then(({ insets }) => {
      for (const [key, value] of Object.entries(insets)) {
        document.documentElement.style.setProperty(`--safe-area-inset-${key}`, `${value}px`)
      }

      SafeArea.addListener('safeAreaChanged', (data) => {
        const { insets } = data
        for (const [key, value] of Object.entries(insets)) {
          document.documentElement.style.setProperty(`--safe-area-inset-${key}`, `${value}px`)
        }
      })
    })
  }
}
